import React from 'react'
import BaseIcon from 'react-icon-base'

const Twitter = props => (
  <BaseIcon width="20" height="16" viewBox="0 0 20 16" {...props}>
    <path
      fill="#55ACEE"
      d="M19.692 1.894c-.732.321-1.512.534-2.326.638.837-.5 1.476-1.285 1.776-2.232-.78.466-1.642.794-2.56.978C15.842.488 14.785 0 13.633 0 11.398 0 9.6 1.814 9.6 4.038c0 .32.027.628.093.92-3.356-.163-6.326-1.772-8.32-4.222-.35.604-.554 1.296-.554 2.04 0 1.399.72 2.638 1.794 3.356-.649-.013-1.285-.2-1.824-.498v.045c0 1.962 1.4 3.591 3.234 3.967-.328.09-.687.132-1.058.132-.259 0-.52-.014-.765-.068.523 1.598 2.008 2.774 3.773 2.812-1.374 1.074-3.118 1.722-5.006 1.722-.33 0-.648-.015-.966-.056C1.788 15.342 3.908 16 6.193 16c7.43 0 11.49-6.154 11.49-11.488 0-.178-.005-.35-.014-.522.801-.568 1.474-1.279 2.023-2.096z"
    />
  </BaseIcon>
)

export default Twitter
